import { render, staticRenderFns } from "./EmergencyCanvas.vue?vue&type=template&id=f045ef3c&scoped=true&"
import script from "./EmergencyCanvas.vue?vue&type=script&lang=js&"
export * from "./EmergencyCanvas.vue?vue&type=script&lang=js&"
import style0 from "./EmergencyCanvas.vue?vue&type=style&index=0&id=f045ef3c&prod&lang=scss&"
import style1 from "./EmergencyCanvas.vue?vue&type=style&index=1&id=f045ef3c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f045ef3c",
  null
  
)

export default component.exports